import { combineReducers } from 'redux';

import containerReducer from './ducks/container';
import filmStripReducer from './ducks/filmstrip';
import performanceHistoryReducer from './ducks/performanceHistory';

const reducers = {
  container: containerReducer,
  filmStrip: filmStripReducer,
  performanceHistory: performanceHistoryReducer,
};

export default combineReducers(reducers);
